export default __webpack_public_path__ + "static/media/welcome-bg.c83c4335.jpg";